import { render, staticRenderFns } from "./ProductOrdersPendingCount.vue?vue&type=template&id=592db360"
import script from "./ProductOrdersPendingCount.vue?vue&type=script&lang=ts"
export * from "./ProductOrdersPendingCount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports